import React, {Component} from 'react';
import {
	contactTypeToIconName,
	getTypeLabel,
	getTypes,
	getTypePrefix,
	getTypePlaceholder,
	getTypeExplanation,
	isPrefixed
} from '../contactHelper';
import './EditContacts.css';
import FlexRow from './FlexRow';
import Dialog from './Dialog';

const types = getTypes();

const mapContactsByType = contacts =>
	contacts.reduce((accum, contact) => {
		accum[contact.type] = accum[contact.type] || contact;
		return accum;
	}, {});

class EditContacts extends Component {
	constructor() {
		super();

		// Create a change handler for each contact type
		this.onTypeChange = types.map(type => e => {
			if (this.props.onChange) this.props.onChange(type, e.target.value);
		});
	}

	render() {
		if (!this.props.contacts) return null;
		const contacts = mapContactsByType(this.props.contacts);

		return (
			<Dialog
				onSave={this.props.onSave}
				onCancel={this.props.onCancel}
				title="Edit contact details">
				<ul className="EditContacts">
					{types.map((contactType, idx) => {
						const contact = contacts[contactType];
						return (
							<li key={contactType}>
								<label>
									<h3>
										<span className={`icon ${contactTypeToIconName(contactType)}`} />
										<span>{getTypeLabel(contactType)}</span>
									</h3>
									<FlexRow>
										{getTypePrefix(contactType) ? (
											<span
												className={`EditContacts-prefix ${
													isPrefixed(contactType, contact && contact.detail) ? 'hidden' : 'shown'
												}`}>
												{getTypePrefix(contactType)}
											</span>
										) : (
											undefined
										)}
										<input
											className="EditContacts-entry"
											placeholder={getTypePlaceholder(contactType)}
											value={contact ? contact.detail : ''}
											onChange={this.onTypeChange[idx]}
										/>
									</FlexRow>
									{getTypeExplanation(contactType) ? (
										<p className="EditContacts-explanation">{getTypeExplanation(contactType)}</p>
									) : (
										undefined
									)}
								</label>
							</li>
						);
					})}
				</ul>
			</Dialog>
		);
	}
}

export default EditContacts;



// WEBPACK FOOTER //
// ./src/widgets/EditContacts.js